import React from "react";
import { useHistory } from "react-router-dom";
import { QrReader } from "react-qr-reader";

import { Page } from "ui/components";

const ScanScreen = () => {
  const History = useHistory();

  const $onScan = async (e) => {
    const getId = (url) => url?.substring(url?.lastIndexOf("/") + 1);

    const getTarget = (url) =>
      url?.substring((0, url?.lastIndexOf("/", url?.lastIndexOf("/") - 1) + 1));

    const id = getId(e);
    const target = getTarget(e)?.replace(`/${getId(e)}`, "");

    if (target === "manifest") {
      History.push(`/manifest/${id}`);
    } else if (target === "shipment") {
      History.push(`/shipment/${id}`);
    }
  };

  return (
    <Page hasFooter full>
      <div className="position-relative">
        <div
          className="position-absolute top-0 start-50 translate-middle-x text-white"
          style={{ zIndex: 9, fontSize: 20, marginTop: 40 }}
        >
          SCAN QR-CODE
        </div>

        <div
          className="position-absolute top-50 start-50 translate-middle border border-2 rounded rounded-5 border-white"
          style={{ zIndex: 9, height: 250, width: 250 }}
        />
        <QrReader
          scanDelay={1000}
          onResult={(result, error) => {
            if (!!result) {
              $onScan(result?.text);
            }
          }}
          style={{ width: "100%", height: "100%" }}
          constraints={{
            facingMode: "environment",
          }}
          videoContainerStyle={{ height: "100%" }}
          containerStyle={{ height: "85vh", width: "100vw" }}
        />
      </div>
    </Page>
  );
};

export default ScanScreen;
